import React, { useEffect, useState} from 'react';
import "leaflet/dist/leaflet.css"
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import pinBiru from "assets/images/icons/pin-biru.svg";
import pinAbu from "assets/images/icons/pin-abu.svg";

// Fungsi untuk menambahkan ikon pada marker
const customIcon = new L.Icon({
  iconUrl: pinBiru,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Komponen untuk update posisi ketika location berubah
const MapUpdater = ({ location }) => {
  const map = useMap();

  useEffect(() => {
    if (location && location.length > 0) {
      const firstLocation = location[0];
      map.setView([firstLocation.lat, firstLocation.lng], 13);
    }
  }, [location, map]);

  return null;
};

// Komponen untuk recenter map ketika lokasi berubah
function RecenterMap({ lat, lng }) {
  const map = useMap();
  useEffect(() => {
    if (lat && lng) {
      map.setView([lat, lng], map.getZoom());
    }
  }, [lat, lng, map]);
  return null;
}

const MapWithMarker = ({ location = [], containerId = "default-map" }, key) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || location.length === 0) return null;
  if (!location || location.length === 0) return null; // ⛔ Hindari render saat kosong

  const firstLocation = location[0];
// console.log("CONTAINE ID : ", containerId)
// console.log("KEY  : ", key)

  return (
    <MapContainer
      id={containerId} // ✅ tiap pemanggilan wajib unik
      // key={key} 
      center={[firstLocation.lat, firstLocation.lng]}
      zoom={13}
      className="z-0 rounded-xl w-full xs:w-[366px] max-h-[366px] h-[50vh]"
    > 
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />

     {/* ✅ ini yang bikin map auto geser ke lokasi baru */}
     <RecenterMap lat={firstLocation.lat} lng={firstLocation.lng} />
      
      {/* Tambahkan Marker di lokasi yang diinginkan */}
      {location?.map((val, i) => (
        <Marker key={i} position={[val.lat, val.lng]} icon={customIcon}>
          <Popup>
            {val.label} "{val.layanan}"
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default MapWithMarker;
